export function isDigitOnlyKeyAllowed(event: KeyboardEvent): boolean {
  const hasModifier = event.ctrlKey || event.metaKey || event.altKey;
  if (hasModifier || event.key.length > 1) {
    return true;
  }

  return /^[0-9]$/.test(event.key);
}
